import { hasPermission } from './auth'

function updateVisibility(element, binding) {
  // 嵌入组件由短期凭证和独立API授权，不能套用独立站会话的按钮权限。
  const embedded = window.location.pathname.startsWith('/embed/')
  element.style.display = embedded || hasPermission(binding.value) ? '' : 'none'
}

export default { inserted: updateVisibility, update: updateVisibility }
